require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var ReactDOM = require('react-dom');

___$insertStyle(".searchGroup {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.searchBar {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  border: 1px solid black;\n  padding: 0.25rem 0.5rem;\n  font-size: 16px;\n  font-weight: bold;\n  height: 30px;\n}\n\n.searchBtn {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  border: 1px solid black;\n  font-size: 16px;\n  font-weight: bold;\n  border-left: 0px;\n  padding: 0.25rem 0.5rem;\n  height: 40px;\n}\n\n.searchBtn:hover {\n  cursor: pointer;\n}\n\n.listSuggestions {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  border-radius: 0.5rem;\n}\n\n.suggestion {\n  padding: 0.25rem 0.5rem;\n  text-align: left;\n  border: 0;\n  border-radius: inherit;\n  color: inherit;\n  background-color: inherit;\n  font-size: 16px;\n}\n\n.suggestion:hover {\n  cursor: pointer;\n}\n\n.suggestion:hover,\n.suggestion:focus {\n  font-weight: bold;\n  border-radius: 0.5rem;\n}");

function Suggestions(_a) {
  var onSuggestClick = _a.onSuggestClick,
      suggestData = _a.suggestData,
      suggestContainerClassName = _a.suggestContainerClassName,
      suggestClassName = _a.suggestClassName;

  function renderSuggestions() {
    return suggestData.map(function (suggestion, index) {
      return React.createElement("button", {
        key: index,
        className: ["suggestion", suggestClassName].join(" "),
        onClick: function onClick() {
          return onSuggestClick(suggestion);
        }
      }, suggestion);
    });
  }

  return React.createElement("div", {
    className: ["listSuggestions", suggestContainerClassName].join(" ")
  }, renderSuggestions());
}

function areEqual(prevProps, nextProps) {
  return JSON.stringify(prevProps.suggestData) === JSON.stringify(nextProps.suggestData);
}

var Suggestions$1 = React.memo(Suggestions, areEqual);
var useState = React.useState,
    useRef = React.useRef,
    useEffect = React.useEffect;

var SuggestBar = function SuggestBar(_a) {
  var inputValue = _a.inputValue,
      inputType = _a.inputType,
      inputPlaceholder = _a.inputPlaceholder,
      onInputChange = _a.onInputChange,
      onInputSubmit = _a.onInputSubmit,
      submitBtn = _a.submitBtn,
      suggestData = _a.suggestData,
      onSuggestClick = _a.onSuggestClick,
      containerClassName = _a.containerClassName,
      inputClassName = _a.inputClassName,
      submitBtnClassName = _a.submitBtnClassName,
      suggestContainerClassName = _a.suggestContainerClassName,
      suggestClassName = _a.suggestClassName;

  var _b = useState(false),
      suggestShow = _b[0],
      setSuggestShow = _b[1];

  var nodeSearchGroup = useRef(null);
  useEffect(function () {
    var domNode = ReactDOM.findDOMNode(nodeSearchGroup.current);

    function handler(evt) {
      if (!(domNode === null || domNode === void 0 ? void 0 : domNode.contains(evt.target))) {
        setSuggestShow(false);
      }
    }

    document.addEventListener("mousedown", handler);
    document.addEventListener("keydown", handler);
    document.addEventListener("keyup", handler);
    return function cleanup() {
      window.removeEventListener("mousedown", handler);
      window.removeEventListener("keydown", handler);
      window.removeEventListener("keyup", handler);
    };
  }, []);

  function handleInputChange(evt) {
    onInputChange(evt);

    if (evt.target.value.length > 0) {
      setSuggestShow(true);
    } else {
      setSuggestShow(false);
    }
  }

  function handleInputSubmit() {
    onInputSubmit();
    setSuggestShow(false);
  }

  function handleInputFocus() {
    if (inputValue.length > 0 && suggestData.length > 0) {
      setSuggestShow(true);
    }
  }

  function handleSuggestClick(suggestion) {
    onSuggestClick(suggestion);
    setSuggestShow(false);
  }

  function handleKeyPress(key) {
    if (key === "Enter") {
      onInputSubmit();
    }
  }

  return React.createElement("div", {
    ref: nodeSearchGroup,
    className: ["searchGroup", containerClassName].join(" ")
  }, React.createElement("input", {
    className: ["searchBar", inputClassName].join(" "),
    type: inputType,
    value: inputValue,
    placeholder: inputPlaceholder,
    onChange: function onChange(e) {
      return handleInputChange(e);
    },
    onFocus: handleInputFocus,
    onSubmit: handleInputSubmit,
    onKeyPress: function onKeyPress(_a) {
      var key = _a.key;
      return handleKeyPress(key);
    }
  }), suggestShow && suggestData.length > 0 ? React.createElement(Suggestions$1, {
    onSuggestClick: function onSuggestClick(suggestion) {
      return handleSuggestClick(suggestion);
    },
    suggestData: suggestData,
    suggestContainerClassName: suggestContainerClassName,
    suggestClassName: suggestClassName
  }) : null, React.createElement("button", {
    className: ["searchBtn", submitBtnClassName].join(" "),
    onClick: handleInputSubmit
  }, submitBtn));
};

SuggestBar.defaultProps = {
  inputType: "text",
  inputPlaceholder: "",
  submitBtn: "Ok"
};
exports["default"] = SuggestBar;